import { ReferredPageRoutingModule } from './referred-routing.module';

import { ReferredPage } from './referred.page';

import { ComponentsModule } from '../../components/components.module';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { SwiperModule } from 'swiper/angular';
import { IonicModule } from '@ionic/angular';

import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {ModalModule} from "src/app/modal/modal.module";
import { EstadoPipe, MonedaSimboloPipe } from './estado.pipe';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  imports: [
    SwiperModule,
    ComponentsModule,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    ModalModule,
    ReferredPageRoutingModule,
  ],
  declarations: [ReferredPage,EstadoPipe, MonedaSimboloPipe ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReferredPageModule {}
